import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, RouterModule } from '@angular/router';
import { RegistrationVerificationService } from '../../core/services/registration-verification.service';

@Component({
  selector: 'app-email-verification',
  standalone: true,
  imports: [CommonModule, RouterModule],
  templateUrl: './email-verification.component.html',
  styleUrls: ['./email-verification.component.css']
})
export class EmailVerificationComponent implements OnInit {
  isLoading = true;
  isSuccess = false;
  message = 'Confirming your email address...';

  constructor(
    private route: ActivatedRoute,
    private verificationService: RegistrationVerificationService
  ) {}

  ngOnInit(): void {
    const token = this.route.snapshot.queryParamMap.get('token');

    if (!token) {
      this.isLoading = false;
      this.isSuccess = false;
      this.message = 'Verification token is missing. Please use the latest verification link from your email.';
      return;
    }

    this.verificationService.confirmEmailVerificationFromLink(token).subscribe({
      next: result => {
        this.isLoading = false;
        this.isSuccess = true;
        this.message = result.message || 'Email confirmed successfully. You can now continue with sign in when your account status allows it.';
      },
      error: error => {
        console.error('Email verification failed:', error);
        this.isLoading = false;
        this.isSuccess = false;
        this.message = this.getErrorMessage(error);
      }
    });
  }

  private getErrorMessage(error: any): string {
    if (typeof error?.error === 'string') {
      return error.error;
    }

    return error?.error?.message
      || error?.message
      || 'Email verification failed. The link may be invalid or expired.';
  }
}
